import React,{useEffect} from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import { doc } from 'firebase/firestore'; 
import { useFirestoreDocData, useFirestore } from 'reactfire';
import Skeleton from '@material-ui/lab/Skeleton';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';

const useStyles = makeStyles((theme) => ({
  chip: {
    marginLeft: theme.spacing(0.5),
  }
}));


export const FruitFacebookGroup = ({
  facebookGroupId,
  key,
}: {
  facebookGroupId: string;
  key: number;
}) => {
  const classes = useStyles();
  const {addRequestGroupId,removeRequestedGroupId} = useHarvestingContext();
  const db = useFirestore();
  const ref = doc(db, 'facebookGroup', facebookGroupId);

  const { status, data } = useFirestoreDocData(ref);

  useEffect(()=>{

    if(status!=='loading'&& data === undefined){
      addRequestGroupId(facebookGroupId);
    }
    else{
      removeRequestedGroupId(facebookGroupId);
    }
  },[data]);
  return (
    <Chip
      size='small'
      key={key}
      label={data?data.name:<Skeleton variant="text" width={60}/>}
      className={classes.chip}
    />
  );
};
